import * as math from 'mathjs';
import { memo } from 'react';

function insertRight(expr, values, prefix) {
  let s = expr;
  for (let i = values.length - 1; i >= 0; i--) {
    if (values[i] == null) continue;
    s = s.replace(new RegExp(`${prefix}${i}`, 'g'), values[i].toFixed(6));
  }
  return s;
}

/**
 * SVG function curve overlay. Evaluates f(x1) at noSegments+1 points.
 * @param {{ axis, params, tParams, derived, functionText, color, dashArray, strokeWidth, noSegments, showRegion }} props
 */
function IntFigFunction({
  axis,
  params, tParams, derived,
  functionText,
  color = '#1f76D2',
  dashArray = '0 0',
  strokeWidth = 0.02,
  noSegments = 100,
  showRegion = false,
}) {
  let xs, ys;
  try {
    let expr = insertRight(functionText, tParams, 'tp');
    expr = insertRight(expr, params, 'p');
    expr = insertRight(expr, derived, 'd');
    expr = expr.replace(/\s/g, '').replaceAll('+-', '-');

    const compiled = math.compile(expr);
    const inc = (axis.max_x - axis.min_x) / noSegments;
    xs = Array.from({ length: noSegments + 1 }, (_, i) => i / noSegments);
    ys = Array.from({ length: noSegments + 1 }, (_, i) => {
      const xVal = axis.min_x + i * inc;
      const yVal = compiled.evaluate({ x1: xVal });
      return 1 - (yVal - axis.min_y) / (axis.max_y - axis.min_y);
    });
  } catch {
    return null;
  }

  return (
    <svg
      width="100%" height="100%"
      viewBox="0 0 1 1"
      preserveAspectRatio="none"
      style={{ position: 'absolute', inset: 0 }}
    >
      {xs.slice(0, -1).map((x, i) => (
        <line
          key={i}
          x1={xs[i]} y1={ys[i]}
          x2={xs[i + 1]} y2={ys[i + 1]}
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeDasharray={dashArray}
        />
      ))}
    </svg>
  );
}

export default memo(IntFigFunction);
